<!--
  CguaConsentCard — explicit CGUA acceptance gate shown before the Email/Google choice.
  One tap on "J'accepte et je continue" is the affirmative act; the CGUA link the tap refers to
  sits in the preceding intro bubble (signupIntro). Presentational: emits `accept`; the
  orchestrator (acceptCgua) sets cguAccepted + reveals the auth-choice card. `disabled` blocks
  double taps.
-->
<template>
  <div class="cgua-consent-card">
    <button type="button" class="cta cta-blue" :disabled="disabled" @click="$emit('accept')">
      J'accepte et je continue
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false })
defineEmits<{ accept: [] }>()
</script>

<style scoped>
.cgua-consent-card {
  width: 92%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
}
.cta {
  width: 100%;
  padding: 14px 16px;
  border: none;
  border-radius: 12px;
  background: var(--brand-default);
  color: var(--white);
  font-size: 14px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  line-height: 14px;
  transition:
    background 0.15s,
    opacity 0.15s;
}
.cta:hover:not(:disabled) {
  background: var(--blue-800);
}
.cta:disabled {
  background: #d1d9e0; /* off-palette disabled grey — DS pass to arbitrate */
  color: var(--grey-500);
  cursor: not-allowed;
}
</style>
